// @flow

import React, { Fragment, Component } from 'react'
import renderUIError from 'helper/renderUIError'

type Props = {
  ui: {
    errors: [],
  },
  company: {
    name: string,
    corpNameKana: string,
    businessTaxId: string,
    ceoFamilyName: string,
    ceoGivenName: string,
    ceoFamilyNameKana: string,
    ceoGivenNameKana: string,
    postalCode: string,
    state: string,
    city: string,
    address1: string,
    address2: string,
    tel: string,
    profileImage: string,
  },
  onChangeCompany: Function,
}

export default class Company extends Component<Props> {
  profileImageInputRef: HTMLInputElement

  onSelectFile = e => {
    const { onChangeCompany } = this.props
    if (e.target.files.length > 0) {
      const reader = new FileReader()
      reader.addEventListener(
        'load',
        () => {
          onChangeCompany('profileImage', reader.result)
        },
        false,
      )

      reader.readAsDataURL(e.target.files[0])
    }
  }

  render() {
    const { ui, company, onChangeCompany } = this.props

    return (
      <Fragment>
        <h2 className="business-setting-title">会社情報</h2>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>法人番号
          </p>
          <input
            type="text"
            value={company.businessTaxId}
            onChange={e => onChangeCompany('businessTaxId', e.target.value)}
            className={`business-reservation-setting__form business__form ${
              renderUIError.hasError('name', ui.errors) ? 'form-error' : ''
            }`}
            placeholder="9011301020099"
          />
          {renderUIError.settingError('businessTaxId', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>会社名
          </p>
          <input
            type="text"
            value={company.name}
            onChange={e => onChangeCompany('name', e.target.value)}
            className={`business-reservation-setting__form business__form ${
              renderUIError.hasError('name', ui.errors) ? 'form-error' : ''
            }`}
            placeholder="株式会社スペースマーケット"
          />
          {renderUIError.settingError('name', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>
            会社名カナ
          </p>
          <input
            type="text"
            value={company.corpNameKana}
            onChange={e => onChangeCompany('corpNameKana', e.target.value)}
            className={`business-reservation-setting__form business__form ${
              renderUIError.hasError('corpNameKana', ui.errors)
                ? 'form-error'
                : ''
            }`}
            placeholder="カブシキガイシャスペースマーケット"
          />
          {renderUIError.settingError('corpNameKana', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>
            代表者氏名
          </p>
          <input
            type="text"
            value={company.ceoFamilyName}
            onChange={e => onChangeCompany('ceoFamilyName', e.target.value)}
            className={`business-reservation-setting__form business__form business__form-name mr20 ${
              renderUIError.hasError('ceoFamilyName', ui.errors)
                ? 'form-error'
                : ''
            }`}
            placeholder="代表"
          />
          <input
            type="text"
            value={company.ceoGivenName}
            onChange={e => onChangeCompany('ceoGivenName', e.target.value)}
            className={`business-reservation-setting__form business__form business__form-name ${
              renderUIError.hasError('ceoGivenName', ui.errors)
                ? 'form-error'
                : ''
            }`}
            placeholder="太郎"
          />
          {renderUIError.settingError('ceoFamilyName', ui.errors)}
          {renderUIError.settingError('ceoGivenName', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>
            代表者氏名カナ
          </p>
          <input
            type="text"
            value={company.ceoFamilyNameKana}
            onChange={e => onChangeCompany('ceoFamilyNameKana', e.target.value)}
            className={`business-reservation-setting__form business__form business__form-name mr20 ${
              renderUIError.hasError('ceoFamilyNameKana', ui.errors)
                ? 'form-error'
                : ''
            }`}
            placeholder="タントウ"
          />
          <input
            type="text"
            value={company.ceoGivenNameKana}
            onChange={e => onChangeCompany('ceoGivenNameKana', e.target.value)}
            className={`business-reservation-setting__form business__form business__form-name ${
              renderUIError.hasError('ceoGivenNameKana', ui.errors)
                ? 'form-error'
                : ''
            }`}
            placeholder="タロウ"
          />
          {renderUIError.settingError('ceoFamilyNameKana', ui.errors)}
          {renderUIError.settingError('ceoGivenNameKana', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>郵便番号
          </p>
          <input
            type="text"
            value={company.postalCode}
            onChange={e => onChangeCompany('postalCode', e.target.value)}
            className={`business-reservation-setting__form business__form ${
              renderUIError.hasError('postalCode', ui.errors)
                ? 'form-error'
                : ''
            }`}
            placeholder="1600023"
          />
          {renderUIError.settingError('postalCode', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>都道府県
          </p>
          <div className="dib">
            <label className="form-select business-select">
              <select
                id="state"
                value={company.state}
                onChange={e => {
                  onChangeCompany('state', e.target.value)
                  const i = e.nativeEvent.target.selectedIndex
                  onChangeCompany('stateText', e.nativeEvent.target[i].text)
                }}
                className={`business-reservation-setting__form business__form ${
                  renderUIError.hasError('state', ui.errors) ? 'form-error' : ''
                }`}
              >
                <option value="tokyo">東京都</option>
                <option value="kanagawa">神奈川県</option>
                <option value="chiba">千葉県</option>
                <option value="saitama">埼玉県</option>
                <option value="ibaraki">茨城県</option>
                <option value="tochigi">栃木県</option>
                <option value="gunma">群馬県</option>
                <option value="osaka">大阪府</option>
                <option value="hokkaido">北海道</option>
                <option value="aomori">青森県</option>
                <option value="iwate">岩手県</option>
                <option value="miyagi">宮城県</option>
                <option value="akita">秋田県</option>
                <option value="yamagata">山形県</option>
                <option value="fukushima">福島県</option>
                <option value="niigata">新潟県</option>
                <option value="toyama">富山県</option>
                <option value="ishikawa">石川県</option>
                <option value="fukui">福井県</option>
                <option value="yamanashi">山梨県</option>
                <option value="nagano">長野県</option>
                <option value="gifu">岐阜県</option>
                <option value="shizuoka">静岡県</option>
                <option value="aichi">愛知県</option>
                <option value="mie">三重県</option>
                <option value="shiga">滋賀県</option>
                <option value="kyoto">京都府</option>
                <option value="hyogo">兵庫県</option>
                <option value="nara">奈良県</option>
                <option value="wakayama">和歌山県</option>
                <option value="tottori">鳥取県</option>
                <option value="shimane">島根県</option>
                <option value="okayama">岡山県</option>
                <option value="hiroshima">広島県</option>
                <option value="yamaguchi">山口県</option>
                <option value="tokushima">徳島県</option>
                <option value="kagawa">香川県</option>
                <option value="ehime">愛媛県</option>
                <option value="kouchi">高知県</option>
                <option value="fukuoka">福岡県</option>
                <option value="saga">佐賀県</option>
                <option value="nagasaki">長崎県</option>
                <option value="kumamoto">熊本県</option>
                <option value="oita">大分県</option>
                <option value="miyazaki">宮崎県</option>
                <option value="kagoshima">鹿児島県</option>
                <option value="okinawa">沖縄県</option>
              </select>
            </label>
          </div>
          {renderUIError.settingError('state', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>市区町村
          </p>
          <input
            type="text"
            value={company.city}
            onChange={e => onChangeCompany('city', e.target.value)}
            className={`business-reservation-setting__form business__form ${
              renderUIError.hasError('city', ui.errors) ? 'form-error' : ''
            }`}
            placeholder="新宿区"
          />
          {renderUIError.settingError('city', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>
            町名・番地
          </p>
          <input
            type="text"
            value={company.address1}
            onChange={e => onChangeCompany('address1', e.target.value)}
            className={`business-reservation-setting__form business__form ${
              renderUIError.hasError('address1', ui.errors) ? 'form-error' : ''
            }`}
            placeholder="西新宿6-15-1"
          />
          {renderUIError.settingError('address1', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__optional">任意</span>
            ビル名・部屋番号
          </p>
          <input
            type="text"
            value={company.address2}
            onChange={e => onChangeCompany('address2', e.target.value)}
            className={`business-reservation-setting__form business__form ${
              renderUIError.hasError('address2', ui.errors) ? 'form-error' : ''
            }`}
            placeholder="ラ・トゥール新宿608"
          />
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading">
            <span className="icon-form icon-form__required">必須</span>電話番号
          </p>
          <input
            type="text"
            value={company.tel}
            onChange={e => onChangeCompany('tel', e.target.value)}
            className={`business-reservation-setting__form business__form ${
              renderUIError.hasError('tel', ui.errors) ? 'form-error' : ''
            }`}
            placeholder="0312345678"
          />
          {renderUIError.settingError('tel', ui.errors)}
        </li>
        <li className="business-reservation-setting__line">
          <p className="business-reservation-setting__heading business-reservation-setting__heading-upload">
            <span className="icon-form icon-form__optional">任意</span>
            会社ロゴ画像
          </p>
          {company.profileImage ? (
            <div
              className="business-reservation-setting__logo"
              onClick={() =>
                this.profileImageInputRef && this.profileImageInputRef.click()
              }
            >
              <div className="business-reservation-setting__logo-done">
                <img
                  src={company.profileImage}
                  alt={company.name}
                  className="business-reservation-setting__logo-img"
                />
              </div>
              <a
                href=""
                className="business-reservation-setting__upload-select"
                onClick={e => {
                  e.preventDefault()
                  this.profileImageInputRef && this.profileImageInputRef.click()
                }}
              >
                ファイルの選択
              </a>
            </div>
          ) : (
            <div
              className="business-reservation-setting__upload"
              onClick={() =>
                this.profileImageInputRef && this.profileImageInputRef.click()
              }
            >
              <i className="fa fa-camera business-reservation-setting__upload-icon" />
              <p>ファイルの選択</p>
            </div>
          )}
          <input
            form="form_company"
            ref={input => {
              this.profileImageInputRef = input
            }}
            type="file"
            name="profileImage"
            id="profileImage"
            hidden
            onChange={this.onSelectFile}
          />
        </li>
      </Fragment>
    )
  }
}
